<script>
import useSharedData from "@/use/SharedData.js";
import useSharedSelectData from "@/use/SharedSelectData";
import {onMounted, ref, watch} from "vue";

export default {
    props: {
        value: Object,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();
        const {workFlowModules, workerPhases} = useSharedSelectData();
        const panelModel = ref(0);

        const filter = ref({});

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});

        onMounted(() => {
            filter.value = props.value;
        })

        return {
            filter,
            workerPhases,
            panelModel,
            inputColor,
            backgroundColor,
            workFlowModules,
        }
    }
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.worker') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-text-field
                                    v-model="filter.code"
                                    :label="$t('common.code')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-text-field
                                    v-model="filter.lastName"
                                    :label="$t('common.lastname')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-text-field
                                    v-model="filter.firstName"
                                    :label="$t('common.firstname')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                    v-model="filter.occupationId"
                                    :label="$t('module.occupation')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.phase"
                                    :items="workerPhases"
                                    :label="$t('worker.status')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.stateId"
                                    type="WORKER_STATE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-control-program-autocomplete
                                    v-model="filter.programIds"
                                    module="worker"
                                    :label="$t('module.control_program')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-issue-autocomplete
                                    v-model="filter.issueIds"
                                    module="worker"
                                    :label="$t('module.issue')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <organizational-chart-select
                                    v-model="filter.organizationalchartIds"
                                    :label="$t('module.organizational_chart')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.workplaceId"
                                    type="WORKER_WORKPLACE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.companyId"
                                    type="WORKER_COMPANY"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-cnas-agcency-autocomplete
                                    v-model="filter.cnasAgencyId"
                                    :label="$t('module.cnas_agency')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <strong>{{ $t('worker.enter_date') }}</strong>
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.enterDateStart"
                                    :label="$t('common.from')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.enterDateEnd"
                                    :label="$t('common.to')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.validation_work_flow') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-work-flow-autocomplete
                                    v-model="filter.workFlowId"
                                    :label="$t('module.validation_work_flow')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.workFlowModules"
                                    :items="workFlowModules"
                                    label="Modules"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-all-step-select
                                    v-model="filter.stepId"
                                    :label="$t('common.state')"
                                    except-final
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-user-autocomplete
                                    v-model="filter.validatorId"
                                    :label="$t('common.validator')"
                                    validator
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <input type="hidden"/>
    </div>
</template>